import React from 'react';

export interface AdminTabDef<T extends string = string> {
  key: T;
  label: string;
  show?: boolean;
}

interface AdminTabsProps<T extends string = string> {
  tabs: AdminTabDef<T>[];
  activeTab: T;
  onChange: (key: T) => void;
  className?: string;
}

function AdminTabs<T extends string = string>({ tabs, activeTab, onChange, className = '' }: AdminTabsProps<T>) {
  return (
    <div className={`flex border-b border-gray-300 mb-6 ${className}`}>
      {tabs
        .filter((t) => t.show !== false)
        .map((t) => (
          <button
            key={t.key}
            className={`px-6 py-2 text-sm font-medium border-b-2 transition ${
              activeTab === t.key
                ? 'border-storyblue text-storyblue'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => onChange(t.key)}
          >
            {t.label}
          </button>
        ))}
    </div>
  );
}

export default AdminTabs;
